import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CookiesProvider } from 'react-cookie';
import { BrowserRouter } from 'react-router-dom';
import UserProvider from './context/UserContext';

import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CookiesProvider>
      <BrowserRouter>
        <UserProvider>
          <App style={{ minHeight: 'calc(100vh - 128px)' }} />
        </UserProvider>
      </BrowserRouter>
      </CookiesProvider>
  </React.StrictMode>
);


